import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getPurchaseHistoryAction } from './purchase-history.actions';
import { IPurchaseHistoryFeature } from './purchase-history.feature.state';
import { failures, getPurchaseHistoryItems, isLoading } from './purchase-history.selectors';

@Injectable()
export class PurchaseHistoryFacade {
  public isLoading$ = this.store.select(isLoading);
  public failures$ = this.store.select(failures);
  public purchaseHistoryItems$ = this.store.select(getPurchaseHistoryItems);

  constructor(private store: Store<IPurchaseHistoryFeature>) {}

  public getPurchaseHistoryItems(): void {
    this.store.dispatch(getPurchaseHistoryAction());
  }
}
